module.exports = __webpack_public_path__ + "components/flag/static/square/ie-1361fa34b51980ef45560d2439638673.svg";